import store from 'store';
import { serializeContactEmails } from './utils';
import {
  ACCOUNTS_EMAIL_ENGAGEMENT_ANALYTICS,
  ANALYTICS_ACCOUNTS_DATA,
  ANALYTICS_DATA_EXPORT,
  ANALYTICS_INTENT_DATA,
  CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS,
  CONTACT_ANALYTICS,
} from 'constants/types';
import { getAccountsEmailEngagementService, getContactsEmailEngagementService } from 'modules/Services/AnalyticsService';
import { SelectOption } from 'modules/Campaigns/interfaces';
import { getDateObject } from 'utils';

// Contacts Email Engagement actions
export const getContactsEmailEngagement = (params: any) => {
  store.dispatch({
    type: CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS.LOAD,
  });
  store.dispatch({
    type: CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS.SET_EXPORT_BUTTON,
    payload: true,
  });

  getContactsEmailEngagementService(params)
    .then((resp: any) => {
      if (resp.data.success) {
        const { contact_details, email_data, click_rate, open_rate, total_emails } = resp.data;
        if (email_data?.length) {
          let emails = serializeContactEmails(email_data);
          // Contact emails data load
          store.dispatch({
            type: CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS.LOAD_SUCCESS,
            payload: { emails, clickRate: click_rate, openRate: open_rate, totalEmails: total_emails, offset: params.offset },
          });
          // Contact's personal data load (for retaining Contact name on page reload)
          store.dispatch({
            type: CONTACT_ANALYTICS.SELECTED_PERSON,
            payload: { selectedPerson: contact_details },
          });
          store.dispatch({
            type: CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS.SET_EXPORT_BUTTON,
            payload: store.getState().emailsEngagement.totalEmails > 0 ? false : true,
          });
        } else {
          //for loading false
          store.dispatch({
            type: CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS.LOAD_FAIL,
          });
        }
        // For export analytics popup
        if (params.export) {
          store.dispatch({
            type: ANALYTICS_DATA_EXPORT.SET_OPEN,
          });
        }
      } else {
        store.dispatch({
          type: CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS.LOAD_FAIL,
        });
      }
    })
    .catch((err: any) => {
      console.error(err);
      if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
        store.dispatch({
          type: CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS.LOAD_FAIL,
        });
      }
    });
};

export const resetContactsEmailEngagement = () => {
  store.dispatch({
    type: CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS.RESET,
  });
};

export const setSearchFlagEmailEngagement = (flag: boolean) => {
  store.dispatch({
    type: CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS.SET_IS_SEARCH,
    payload: flag
  });
};

export const setContactEmailEngagementEmailsByFilter = (label: string) => {
  store.dispatch({
    type: CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS.SET_EMAILS_BY_FILTER,
    payload: label,
  });
};

export const resetContactEmailEngagementDate = () => {
  store.dispatch({
    type: CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS.RESET_DATES,
  });
};

// Accounts Email Engagement actions
export const getAccountsEmailEngagement = (params: any) => {
  store.dispatch({
    type: ACCOUNTS_EMAIL_ENGAGEMENT_ANALYTICS.LOAD,
  });
  store.dispatch({
    type: CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS.SET_EXPORT_BUTTON,
    payload: true,
  });
  getAccountsEmailEngagementService(params)
    .then((resp: any) => {
      if (resp.data.success) {
        const { account_details, email_data, click_rate, open_rate, total_emails, total_campaigns } = resp.data;
        if (email_data?.length) {
          let emails = serializeContactEmails(email_data);
          // Account emails data load
          store.dispatch({
            type: ACCOUNTS_EMAIL_ENGAGEMENT_ANALYTICS.LOAD_SUCCESS,
            payload: {
              emails,
              clickRate: click_rate,
              openRate: open_rate,
              totalEmails: total_emails,
              offset: params.offset,
              totalCampaigns: total_campaigns,
            },
          });
          // Account's data load (for retaining Account name on page reload)
          store.dispatch({
            type: ANALYTICS_ACCOUNTS_DATA.SELECTED_ACCOUNT,
            payload: { selectedAccount: account_details.company_name ?? 'Others' },
          });
          store.dispatch({
            type: CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS.SET_EXPORT_BUTTON,
            payload: store.getState().emailsEngagement.totalEmails > 0 ? false : true,
          });
        } else {
          //for loading false
          store.dispatch({
            type: ACCOUNTS_EMAIL_ENGAGEMENT_ANALYTICS.LOAD_FAIL,
          });
        }
        // For export analytics popup
        if (params.export) {
          store.dispatch({
            type: ANALYTICS_DATA_EXPORT.SET_OPEN,
          });
        }
      } else {
        store.dispatch({
          type: ACCOUNTS_EMAIL_ENGAGEMENT_ANALYTICS.LOAD_FAIL,
        });
      }
    })
    .catch((err: any) => {
      console.error(err);
      if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
        store.dispatch({
          type: ACCOUNTS_EMAIL_ENGAGEMENT_ANALYTICS.LOAD_FAIL,
        });
      }
    });
};

export const resetAccountsEmailEngagement = () => {
  store.dispatch({
    type: ACCOUNTS_EMAIL_ENGAGEMENT_ANALYTICS.RESET,
  });
};

export const setAccountsEmailEngagementEmailsByFilter = (label: string) => {
  store.dispatch({
    type: ACCOUNTS_EMAIL_ENGAGEMENT_ANALYTICS.SET_EMAILS_BY_FILTER,
    payload: label,
  });
};

export const resetAccountsEmailEngagementDate = () => {
  store.dispatch({
    type: ACCOUNTS_EMAIL_ENGAGEMENT_ANALYTICS.RESET_DATES,
  });
};

export const analyticsDatesFilterChangeEmailEngagement = (value: SelectOption, isAccount: boolean) => {
  if (isAccount) {
    store.dispatch({
      type: CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS.SET_DATES_OBJECT,
      payload: value,
    });
    let datesObject: any = getDateObject(value.value);
    store.dispatch({
      type: CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS.SET_DATES,
      ...datesObject,
    });
  } else {
    store.dispatch({
      type: CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS.SET_DATES_OBJECT,
      payload: value,
    });
    let datesObject: any = getDateObject(value.value);
    store.dispatch({
      type: CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS.SET_DATES,
      ...datesObject,
    });
  }
};
